import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { HanteraLagermalFilterComponent } from "./components/hantera-lagermal-filter/hantera-lagermal-filter.component";
import { HanteraLagermalNavigationComponent } from "./components/hantera-lagermal-navigation/hantera-lagermal-navigation.component";
import { HanteraLagermalResultComponent } from "./components/hantera-lagermal-result/hantera-lagermal-result.component";
import { HanteraLagermalComponent } from "./components/hantera-lagermal/hantera-lagermal.component";
import { HanteraLagermalService } from "./hantera-lagermal.service";

@NgModule({
    imports: [
        RaskCommonModule,
        HanteraLagermalComponent,
        HanteraLagermalFilterComponent,
        HanteraLagermalNavigationComponent,
        HanteraLagermalResultComponent
    ],
    providers: [HanteraLagermalService]
})
export class HanteraLagermalModule { }
